<div class="dialog-container">
  <div class="dialog-icon-container">
    <span class="dialog-icon notification">
      <mat-icon>{{ iconName }}</mat-icon>
    </span>
  </div>
  <h2 mat-dialog-title class="dialog-title">{{ data.title || 'Notification' }}</h2>
  <mat-dialog-content class="dialog-content">
    <p class="message-text">{{ data.body || '' }}</p>
  </mat-dialog-content>
  <mat-dialog-actions class="dialog-actions" align="center">
    @for (action of sortedActions; track action.id || $index) {
      @if (isPrimary(action)) {
        <button 
          mat-flat-button 
          color="primary"
          class="action-button confirm-button" 
          (click)="onAction(action)">
          <mat-icon>{{ getActionIcon(action.id) }}</mat-icon>
          {{ getActionLabel(action) }}
        </button>
      } @else {
        <button 
          mat-stroked-button 
          class="action-button cancel-button" 
          [class.destructive-button]="action.style === 'destructive'"
          (click)="onAction(action)">
          <mat-icon>{{ getActionIcon(action.id) }}</mat-icon>
          {{ getActionLabel(action) }}
        </button>
      }
    }
  </mat-dialog-actions>
</div>
